var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.979 13.0137C13.2551 13.0137 13.479 13.2375 13.479 13.5137V14.3232C13.479 14.5994 13.2551 14.8232 12.979 14.8232H8.15186C7.87571 14.8232 7.65186 14.5994 7.65186 14.3232V13.5137C7.65186 13.2375 7.87571 13.0137 8.15186 13.0137H12.979ZM7.75781 8.0332C8.03395 8.0332 8.25781 8.25706 8.25781 8.5332V19.6191C8.25781 19.8953 8.03395 20.1191 7.75781 20.1191H6.5C6.22386 20.1191 6 19.8953 6 19.6191V8.5332C6 8.25706 6.22386 8.0332 6.5 8.0332H7.75781ZM14.6641 8.0332C14.9402 8.0332 15.1641 8.25706 15.1641 8.5332V19.6191C15.1641 19.8953 14.9402 20.1191 14.6641 20.1191H13.4146C13.1384 20.1191 12.9146 19.8953 12.9146 19.6191V8.5332C12.9146 8.25706 13.1384 8.0332 13.4146 8.0332H14.6641Z",
    fill: "#050022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8438 8.21588C21.1672 8.10949 21.5 8.35039 21.5 8.69084V19.5C21.5 19.7761 21.2761 20 21 20H19.7645C19.4884 20 19.2645 19.7761 19.2645 19.5V11.27C19.2645 10.9277 18.9282 10.6866 18.604 10.7965L17.1605 11.2857C16.8363 11.3956 16.5 11.1545 16.5 10.8122V10.0938C16.5 9.88302 16.6322 9.69485 16.8306 9.62342L19.6364 8.61305L20.8438 8.21588Z",
    fill: "#050022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.7e485965bbbded2a927e114b00bc9d4e.svg";
export { ForwardRef as ReactComponent };